'use strict';

/*
 * @ngdoc function
 * @name cimerFrontEndApp.controller:SearchCurriculaCtrl
 * @description
 * # SearchCurriculaCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp')
    .controller('SearchCurriculaCtrl',
    [
        '$scope', '$location', '$uibModal', '$q', 'Session', 'DocumentService', 'BookBagService', '$sce', '$window', '$routeParams',
        function ($scope, $location, $uibModal, $q, Session, DocumentService, BookBagService, $sce, $window, $routeParams) {

            if ($routeParams.roleId) {
                $scope.selectedRoleId = $routeParams.roleId; //parseInt($routeParams.roleId, 10);
            } else {
                $scope.selectedRoleId = '1';
            }

            //Handles asking someone for their login
            var login = function () {
                var loginModal = $uibModal.open({
                    animation: true,
                    templateUrl: '/Content/Templates/loginModal.html?v=' + versionKey,
                    controller: 'loginModalCtrl',
                    resolve: {
                        Session: function () {
                            return Session;
                        }
                    }

                });
                loginModal.rendered.then(function () {
                    $('#username').focus();
                });
                loginModal.result.then(function () {
                    sessionObject = Session.getSessionObject();
                    location.reload();
                }, function () { // close or cancel
                    if ($scope.selectedRoleId === '1') {
                        $location.url('/customMentorCurricula');
                    }
                    else {
                        $location.url('/customMenteeCurricula');
                    }
                });
            };

            //route away if not authenticated
            var sessionObject = Session.getSessionObject();
            if (!sessionObject.isAuthenticated) {
                login();
                return;
            }

            /* Cimer-262: Trainee development areas are associated with "Meta-Learning Objectives" 
             * When filtering on Trainee Development Area, only certain Meta-Learning Objectives should be shown (even if a doc is tagged with the TDA)
             * The TDAs are tags with category ID 4 in the Tags table, the MLOs are tags with category ID 7 in the Tags table
             * We currently don't have a way to associate the MLOs and TDAs in the database, so manually build a map here
             * Cimer sent us the list of which MLOs go with which TDAs, it's in Confluence (CIMER -> Curricula -> Custom Curricula -> Meta-Learning Objectives and Trainee Development Area Associations)
             * If you update the TDA/MLO associations, please update the document as well
             * The tag IDs aren't consistent across Dev/Staging/Prod databases, so we need to use the tag text
             * These tags and associations where updated in Cimer-864 */
            $scope.objectivesDict = {};

            $scope.objectivesDict["1. Foundational Disciplinary Knowledge"] = ["know the fundamental content in their discipline (e.g., frameworks, theories, and models)", "know the history of knowledge generation in their discipline", "know the processes by which new knowledge is generated and evaluated", "ground hypotheses and research questions in established disciplinary knowledge, theories, frameworks, or observations", "know inferences and implications of research findings", "know the ways that content knowledge from other disciplines is related to content knowledge in their discipline"];

            $scope.objectivesDict["2. Practical and Cognitive Research Skills"] = ["use tools and databases to search the disciplinary literature", "use literature search strategies that identify relevant prior research", "use logical and critical thinking in evaluating research", "connect diverse research ideas and approaches in novel and creative ways", "consider alternative approaches and interpretations of research", "make connections between content knowledge in their discipline and content knowledge in other disciplines", "identify gaps in existing knowledge or research results to investigate", "set research goals", "use disciplinary theories, frameworks and models in designing research studies", "provide a logical rationale for their study designs", "know assumptions and limitations in study designs (e.g., reporting uncertainty/error)", "formulate hypotheses and research questions that can be systematically tested or investigated", "select appropriate methods to investigate research questions", "follow standard protocols to collect and store research data", "have up-to-date technical skills to conduct research in the discipline", "develop new data collection or analytical methods when needed", "use troubleshooting skills to address theoretical or technical problems in research", "apply the appropriate analytic and statistical methods to analyze data", "use disciplinary theories, frameworks and models in analyzing data", "interpret the results of data analyses (e.g., coding, mathematical, and statistical calculations)", "interpret or synthesize research findings", "propose new inferences and implications of research findings (their own and/or others’)", "draw conclusions from research findings", "refine existing and/or contribute new disciplinary theories, frameworks, and models based on research findings"];

            $scope.objectivesDict["3. Ethical and Responsible Research Practices"] = ["follow research safety regulations", "follow disciplinary data ownership and stewardship practices", "follow ethical guidelines for working with research data", "follow guidelines for ethical treatment of research subjects (e.g., individuals, communities, animals, etc.)", "follow guidelines for conducting rigorous and reproducible research in their discipline", "follow disciplinary norms and policies regarding credit for contributions to research (e.g., citing previous research, authorship order, acknowledging work)", "recognize and minimize legal issues, ethical issues, and potential conflicts of interest in research", "recognize instances of research misconduct and take steps to address them", "consider the role of social and cultural factors in research", "consider the implications of research to individuals and society", "consider how system structures provide differential access to participation in research", "act to increase access to research for all"];

            $scope.objectivesDict["4. Research Communication Skills"] = ["construct appropriate ways to present and visualize data", "use disciplinary conventions to communicate research (e.g., ideas, results, implications) orally (e.g., conference presentations, invited talks, research team meetings)", "use disciplinary conventions to communicate research (e.g., ideas, results, implications) in writing (e.g., research articles, grant proposals, policy briefs)", "translate research findings into policies and practices", "translate research (e.g., ideas, results, implications) and engage with audiences outside of their research discipline (e.g., scholars in other disciplines, non-research, or general audiences)", "promote and advocate for research through communications to various audiences (e.g., institutions, disciplines, public stakeholders)"];

            $scope.objectivesDict["5. Interpersonal Research Skills"] = ["understand and conduct themselves in accordance with the cultural and social norms of professionals in the discipline", "express respect for others' differences", "use appropriate and effective interpersonal communication practices with research colleagues", "manage difficult conversations and conflicts with research colleagues", "work effectively with others on collaborative and/or interdisciplinary teams", "consider and include multiple perspectives in decision making", "make meaningful contributions to collaborative research projects", "provide critical and constructive feedback on research to colleagues", "accept, interpret, and modify their research based on constructive criticism and feedback from colleagues", "network with other research professionals"];

            $scope.objectivesDict["6. Researcher Self-Beliefs and Attitudes"] = ["proactively set their research goals and secure the guidance and resources needed to achieve those goals", "persevere when problems or challenges arise in research (e.g., unexpected, ambiguous, or uncertain results, failed projects)", "recognize and manage their feelings and behaviors in the research environment", "accurately self-assess their research strengths and weaknesses", "express curiosity in exploring and conducting research", "work at an appropriate level of independence", "manage time to meet individual research project milestones", "develop confidence in their capability to successfully conduct research", "identify themselves as a researcher or expert in their discipline", "engage in practices that support work-life balance (e.g., time management, pursuing interests beyond research)"];

            $scope.objectivesDict["7. Knowledge and Skills to Pursue a Research or Research-Related Career"] = ["are aware of career pathways related to their research training", "identify and clarify a long-term strategic vision for their research career", "translate and apply their research skills and knowledge across career pathways", "are prepared to pursue research career pathways"];

            $scope.objectivesDict["8. Knowledge and Skills to Administer and Manage Research Projects and Teams Develop administrative skills to lead research personnel and projects"] = ["identify and clarify a long-term strategic vision for a program of research", "identify opportunities and make decisions about the research to be done", "mentor other developing researchers using best practices in mentoring", "know how to identify and secure funding (e.g. investments, grants) to support research in their discipline", "estimate and secure the funds needed to conduct research", "track research expenditures", "have the administrative skills to manage research projects and/or heterogenous research teams"];

            $scope.defaultIndex = 0;  //index of the categoriesList that represents the category we will actually display
            //but if we come in as mentee, we need to change the default category 
            if ($scope.selectedRoleId === '2') {
                $scope.defaultIndex = 6;
            }

            $scope.dataLoaded = false;

            $scope.filterSelection = {};
            $scope.searchDropDownsettings = {
                externalIdProp: '',
                idProp: 'TagId',
                displayProp: 'Description',
                enableSearch: false,
                showCheckAll: false,
                showUncheckAll: true,
                showEnableSearchButton: false
            };
            $scope.searchDropDownText = {
                buttonDefaultText: 'All'
            };
            $scope.bookBagList = [];
            $scope.documentList = [];
            $scope.tagDict = {};
            $scope.categoryList = [];
            $scope.researchRoleList = [];
            $scope.tagGroupNames = [];
            $scope.selectedMaterialTypeId = {};
            var complete = {};      //materials type object
            var participant = {};   //materials type object

            //store the complete and participant objects for later use
            var setUpMaterialsType = function () {
                for (var i = 0; i < $scope.tagDict[6].length; i++) {
                    if ($scope.tagDict[6][i].TagId === 49)
                        complete = $scope.tagDict[6][i];
                    else if ($scope.tagDict[6][i].TagId === 50)
                        participant = $scope.tagDict[6][i];
                }
            };

            //set the default value for Materials Type
            var setDefaultMaterialsType = function () {
                $scope.selectedMaterialTypeId = 49; //set Materials Type to Complete
                if (+$scope.selectedRoleId === 2) { //research role is Trainee
                    setUpMaterialsType();
                    $scope.filterSelection[6] = [complete]; //actually filter if it's the right role
                }
            };

            $scope.roleChange = function (role) {
                $scope.selectedRoleId = role;
                $scope.dataLoaded = false;

                if (role === "1") {
                    $scope.defaultIndex = 0;
                } else {
                    //for trainees, we are organizing by meta learning objectives
                    $scope.defaultIndex = 6;
                }

                // Clear all filters on changing role since different filters apply to different roles
                for (var i = 1; i < 8; i++) { // There are 8 filter categories, but since filterSelection isn't an array, we can't use .length. Also it starts at one for an unknown reason, not zero.
                    $scope.filterSelection[i] = [];
                }
                
                setDefaultMaterialsType();

                DocumentService.getDocumentsByResearchRole($scope.selectedRoleId)
                    .then(function (response) {
                        $scope.documentList = response.data;
                        $scope.dataLoaded = true;
                    });
            };

            //update "complete or participant" to filter on either or
            $scope.materialsTypeChange = function (selected) {
                switch (+selected) {
                    case -1: //all
                        $scope.filterSelection[6] = []; 
                        break;
                    case 49:
                        $scope.filterSelection[6] = [complete]; 
                        break;
                    case 50:
                        $scope.filterSelection[6] = [participant];
                        break;
                }
            };

            //Load bookBagService object if available (routed from Bookbag page) and add to document list
            $scope.bookBagObject = BookBagService.getBookBagObject();
            var tempObj = {};
            for (var i = 0; i < $scope.bookBagObject.docs.length; i++) {
                tempObj = {
                    DocumentID: $scope.bookBagObject.docs[i].docID,
                    bookBagDocID: $scope.bookBagObject.docs[i].bookBagDocID,
                    title: $scope.bookBagObject.docs[i].title,
                    docOrder: $scope.bookBagObject.docs[i].docOrder,
                    isSelected: $scope.bookBagObject.docs[i].isSelected
                };
                $scope.bookBagList.push(tempObj);
            }

            DocumentService.getResearchRoles()
                .then(function (result) {
                    $scope.researchRoleList = result.data;
                    // For now, we don't want any Custom Curricula for the Mentoring Up role, so manually remove it here
                    $scope.researchRoleList.splice($scope.researchRoleList.indexOf(3), 1);
                });

            //Get Categories - then set default and grab default documents and tags
            DocumentService.getCategories().then(function (result) {
                $scope.categoryList = result.data;

                //now grab all the tags
                var promises = [];
                for (var i = 0; i < $scope.categoryList.length; i++) {
                    promises.push(
                        DocumentService.getTagsByCategory($scope.categoryList[i].CategoryID)
                    );
                }
                // and documents for the default category ($scope.defaultIndex)
                promises.push(
                    //get all documents for selected role
                    DocumentService.getDocumentsByResearchRole($scope.selectedRoleId)
                );

                $q.all(promises).then(function (responses) {
                    //console.log(responses);
                    for (var i = 0; i < $scope.categoryList.length; i++) {
                        $scope.filterSelection[$scope.categoryList[i].CategoryID] = [];
                        $scope.tagDict[$scope.categoryList[i].CategoryID] = responses[i].data;
                    }

                    //add "All" to beginning of Materials Type list and "Complete or Participant" to end of list
                    var category = $scope.tagDict[6][0].Category;
                    $scope.tagDict[6].unshift({ Category: category, Description: "All", LongDescription: null, TagId: -1, TagOrder: 29}); //add to beginning
                    setUpMaterialsType();
                    setDefaultMaterialsType();

                    $scope.documentList = responses[responses.length - 1].data;
                    for (var tagKey in $scope.documentList) {
                        if ($scope.documentList.hasOwnProperty(tagKey)) {
                            for (var k = 0; k < $scope.documentList[tagKey].length; k++) {
                                $scope.documentList[tagKey][k].isInBookbag = false;

                                for (var j = 0; j < $scope.bookBagList.length; j++) {
                                    if ($scope.documentList[tagKey][k].DocumentID === $scope.bookBagList[j].DocumentID) {
                                        $scope.documentList[tagKey][k].isInBookbag = true;
                                        break;
                                    }
                                }
                            }
                        }
                    } //end for tagKey
                    
                    // Get the grouping tags' description so we can filter them out when displaying the tags
                    for (var m = 0; m < $scope.tagDict[7].length; m++) {
                        $scope.tagGroupNames.push($scope.tagDict[7][m].Description);
                    }

                    $scope.dataLoaded = true;

                    // console.log("categories: ", $scope.categoryList);
                    // console.log("tags: ", $scope.tagDict); 
                    // console.log("documents: ", $scope.documentList);
                });

            }, function (err) {
                $scope.dataLoaded = false;
                console.log(err);
            });

            $scope.filterDefaultCategory = function (tag) {

                var defaultCategoryID = $scope.categoryList[$scope.defaultIndex].CategoryID;

                if ($scope.filterSelection[defaultCategoryID].length === 0) { //if this is empty, nothing has been checked, so all are allowed
                    return true;
                } else {
                    for (var i = 0; i < $scope.filterSelection[defaultCategoryID].length; i++) {
                        //otherwise, if its in the list, its checked, so display
                        if (tag.TagId === $scope.filterSelection[defaultCategoryID][i].TagId) {
                            return true;
                        }
                    }
                    //otherwise don't
                    return false;
                }

            };

            $scope.filterMetaLearningObjectives = function (tag) {
                // We only care about the filter on Training Development area, $scope.filterSelection[4]
                // Return everything if no filter selected
                if ($scope.filterSelection[4].length === 0) { return true; }
                for (var i = 0; i < $scope.filterSelection[4].length; i++) {
                    var devAreaDesc = $scope.filterSelection[4][i].Description;
                    if ($scope.objectivesDict[devAreaDesc].indexOf(tag.Description) > -1) {
                        return true;
                    }
                }
                // If we got here, the tag isn't associated with any of the selected development areas, don't show it
                return false;
            };

            $scope.filterDocuments = function (doc) {

                //check filtering in all non-default categories
                for (var i = 0; i < $scope.categoryList.length; i++) {

                    var categoryID = $scope.categoryList[i].CategoryID;
                    if (i === $scope.defaultIndex) { //skip default category
                        continue;
                    }

                    //check if any of the doc's tags match a tag in the list
                    if ($scope.filterSelection[categoryID].length === 0) { //no filtering on this tag category if empty
                        continue;
                    }
                    var inList = false;
                    for (var j = 0; j < $scope.filterSelection[categoryID].length; j++) {
                        for (var k = 0; k < doc.DocumentTags.length; k++) {
                            if ($scope.filterSelection[categoryID][j].TagId === doc.DocumentTags[k].Tag.TagId) {
                                inList = true;
                                break;
                            }
                        }
                    }

                    //if it wasn't in the list, but there was a list, don't display
                    if (!inList) {
                        return false;
                    }

                }

                //if we made it this far it should be displayed
                return true;
            };

            $scope.filterTagFunction = function () {

                return function (tag) {

                    return true;

                    //TODO: implement me !

                    /* if ($scope.filterSelection[catID].length === 0) { //if this is empty, nothing has been checked, so all are allowed
                         return true;
                     } else {
                         //something has been checked, if checked, display
                         for (var i = 0; i < $scope.filterSelection[catID].length; i++) {
                             if (tag.TagId === $scope.filterSelection[catID][i].TagId) {
                                 return true;
                             }
                         }
                         //otherwise don't display
                         return false;
                     }      */
                };

            };

            $scope.filterTagDisplay = function (tag) {
                return $scope.tagGroupNames.indexOf(tag.Tag.Description) < 0;        
            };

            $scope.updateBookbag = function (document) {
                var duplicateFound = false;

                if (!document.isInBookbag) {
                    //need to actually look in the bookbag to see if there's any with the same id
                    angular.forEach($scope.bookBagList,
                        function(b) {
                            if (b.DocumentID === document.DocumentID) {
                                //don't add anything, but let the document know it's in the bookbag
                                duplicateFound = true;
                            }
                        });
                    if (!duplicateFound) {
                    document.isInBookbag = true;
                    var newOrder = $scope.bookBagList.length + 1;
                        $scope.bookBagList.push({
                            DocumentID: document.DocumentID,
                            bookBagDocID: null,
                            title: document.Title,
                            docOrder: newOrder,
                            isSelected: true
                        });
                    }
                } else {
                    document.isInBookbag = false;
                    for (var i = 0; i < $scope.bookBagList.length; i++) {
                        if ($scope.bookBagList[i].DocumentID === document.DocumentID) {
                            $scope.bookBagList.splice(i, 1);
                            break;
                        }
                    }
                }
            };

            $scope.downloadDocument = function (doc) {
                var fileName = "CustomCurricula_" + doc.FileName;
                DocumentService.getPDFDocumentForDownload(doc.DocumentID).then(function (result) {
                    var file = new Blob([result.data], { type: 'application/pdf' });
                    var fileURL = window.URL.createObjectURL(file);
                    var content = $sce.trustAsResourceUrl(fileURL);
                    //$window.open(content, '_blank');
                }, function () {
                    $scope.DocPreview = null;
                    a.click();
                }, function () {
                    $scope.DocPreview = null;
                });
            };

            $scope.goToBookBag = function () {

                //save current document list to BookBagService to pass to bookbag service if there's anything there:
                var tempDocs = [];
                for (var i = 0; i < $scope.bookBagList.length; i++) {
                    tempDocs.push({
                        docID: $scope.bookBagList[i].DocumentID,
                        bookBagDocID: $scope.bookBagList[i].bookBagDocID,
                        title: $scope.bookBagList[i].title,
                        docOrder: $scope.bookBagList[i].docOrder,
                        isSelected: $scope.bookBagList[i].isSelected
                    });
                }
                BookBagService.saveBookBagObject({
                    bookBagID: $scope.bookBagObject.bookBagID,
                    name: $scope.bookBagObject.name,
                    description: $scope.bookBagObject.description,
                    docs: tempDocs
                });

                $location.url('/myCurricula');
            };

}]);